import type { RouteRecordRaw } from 'vue-router'

const waterSamplesRoutes: RouteRecordRaw[] = [
  {
    path: '/water-samples',
    name: 'water-samples.index',
    component: () => import('@/modules/technical/water-samples/views/WaterSamplesIndex.vue'),
    meta: {
      pageTitle: 'Water samples',
      breadcrumbs: ['Water samples']
    }
  },
  {
    path: '/water-samples/create',
    name: 'water-samples.create',
    component: () => import('@/modules/technical/water-samples/views/WaterSamplesEdit.vue'),
    meta: {
      pageTitle: 'Water samples',
      breadcrumbs: ['Water samples']
    }
  },
  {
    path: '/water-samples/:id/edit',
    name: 'water-samples.edit',
    component: () => import('@/modules/technical/water-samples/views/WaterSamplesEdit.vue'),
    meta: {
      pageTitle: 'Water samples',
      breadcrumbs: ['Water samples']
    }
  }
]

export default waterSamplesRoutes
